import { useMutation } from '@tanstack/react-query'
import { useFetch } from './useFetch'

type Params = {
  id: string
  archive: boolean
}

export function usePromotionArchive() {
  const { fetcherWrapper } = useFetch()

  const mutation = (params: Params) => {
    const { id, archive } = params

    const url = new URL(
      `/api/proxy/rnb/pvt/${
        archive ? 'archive' : 'unarchive'
      }/calculatorconfiguration/${id}`,
      window.location.origin
    )

    return fetcherWrapper(url, {
      method: 'POST',
    })
  }

  const { mutateAsync: update, isPending } = useMutation({
    mutationFn: mutation,
  })

  return {
    update,
    isLoading: isPending,
  }
}
